var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableCloudStorageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2615_34829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.406 8.342C12.4055 7.48014 13.6802 7.00414 15 7C17.69 7 19.923 9 20.166 11.579C21.758 11.804 23 13.137 23 14.773C23 16.569 21.502 18 19.687 18H17C16.8674 18 16.7402 17.9473 16.6464 17.8536C16.5527 17.7598 16.5 17.6326 16.5 17.5C16.5 17.3674 16.5527 17.2402 16.6464 17.1464C16.7402 17.0527 16.8674 17 17 17H19.688C20.979 17 22 15.988 22 14.773C22 13.557 20.98 12.545 19.687 12.545H19.187V12.045C19.188 9.825 17.328 8 15 8C13.9199 8.00431 12.8768 8.39443 12.059 9.1C11.302 9.752 10.906 10.538 10.906 11.155V11.603L10.461 11.652C9.064 11.805 8 12.952 8 14.318C8 15.785 9.23 17 10.781 17H13C13.1326 17 13.2598 17.0527 13.3536 17.1464C13.4473 17.2402 13.5 17.3674 13.5 17.5C13.5 17.6326 13.4473 17.7598 13.3536 17.8536C13.2598 17.9473 13.1326 18 13 18H10.781C8.708 18 7 16.366 7 14.318C7 12.555 8.266 11.095 9.942 10.725C10.085 9.862 10.64 9.002 11.406 8.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6457 22.854C14.6921 22.9006 14.7473 22.9375 14.808 22.9627C14.8688 22.9879 14.9339 23.0009 14.9997 23.0009C15.0654 23.0009 15.1305 22.9879 15.1913 22.9627C15.252 22.9375 15.3072 22.9006 15.3537 22.854L18.3537 19.854C18.4475 19.7601 18.5003 19.6328 18.5003 19.5C18.5003 19.3672 18.4475 19.2399 18.3537 19.146C18.2598 19.0521 18.1324 18.9994 17.9997 18.9994C17.8669 18.9994 17.7395 19.0521 17.6457 19.146L15.4997 21.293V12.5C15.4997 12.3674 15.447 12.2402 15.3532 12.1464C15.2594 12.0527 15.1323 12 14.9997 12C14.867 12 14.7399 12.0527 14.6461 12.1464C14.5523 12.2402 14.4997 12.3674 14.4997 12.5V21.293L12.3537 19.146C12.2598 19.0521 12.1324 18.9994 11.9997 18.9994C11.8669 18.9994 11.7395 19.0521 11.6457 19.146C11.5518 19.2399 11.499 19.3672 11.499 19.5C11.499 19.6328 11.5518 19.7601 11.6457 19.854L14.6457 22.854Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2615_34829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCloudStorageIcon);
export default __webpack_public_path__ + "static/media/table-cloud-storage-icon.15b9d4eb6b008c9af308077d9526f3d1.svg";
export { ForwardRef as ReactComponent };